module.exports = __webpack_public_path__ + "static/media/guest-cards-alt.b1e83eff.svg";